import { useEffect, useRef, useState } from "react";
import { Play } from "lucide-react";

/** Play glyph with a continuous thin red pulse ring; runs only while on screen, honours prefers-reduced-motion. */
export default function PlayPulse({ className = "" }) {
    const ref = useRef(null);
    const [on, setOn] = useState(true);
    useEffect(() => {
        const el = ref.current; if (!el || !("IntersectionObserver" in window)) return;
        const io = new IntersectionObserver(([e]) => setOn(e.isIntersecting), { threshold: 0.1 });
        io.observe(el);
        return () => io.disconnect();
    }, []);
    return (
        <span ref={ref} className={`play-pulse ${on ? "is-on" : ""} ${className}`} aria-hidden="true" data-testid="play-pulse" data-on={on}>
            <Play className="play-pulse-icon" fill="currentColor" />
        </span>
    );
}
